"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const storage_1 = require("./services/storage");
let worker = null;
function getNotifications({ context, userPq, userRecom, addNotifications, customer, }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            switch ((0, storage_1.getLoggedStatus)()) {
                case constants_1.LOGGED_STATUS.PUBLIC: {
                    const { publicNotificationController } = yield Promise.resolve().then(() => __importStar(require("./controllers/public.js")));
                    yield publicNotificationController({
                        worker,
                        context,
                        userPq,
                        userRecom,
                        addNotifications,
                        customer,
                    });
                    return;
                }
                case constants_1.LOGGED_STATUS.SOFTLOGGED: {
                    const { softloggedNotificationController } = yield Promise.resolve().then(() => __importStar(require("./controllers/softlogged")));
                    yield softloggedNotificationController({
                        worker,
                        context,
                        userPq,
                        userRecom,
                        addNotifications,
                        customer,
                    });
                    return;
                }
                case constants_1.LOGGED_STATUS.LOGGED: {
                    const { loggedNotificationController } = yield Promise.resolve().then(() => __importStar(require("./controllers/logged")));
                    yield loggedNotificationController({
                        worker,
                        context,
                        userPq,
                        userRecom,
                        addNotifications,
                        customer,
                    });
                    return;
                }
                default:
                    return;
            }
        }
        catch (e) {
            console.log("Notifications error: ", JSON.stringify(e), e);
        }
    });
}
exports.default = getNotifications;
//# sourceMappingURL=index.js.map